import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const kustomer = defineConnector({
  identifier: "kustomer",
  name: "Kustomer",
  tagLine: "Customer service CRM",
  logo,
  protocol: "http",
  tags: ["communication", "productivity"],
  defaultUrlPattern: () => "https://(?:.*\\.)?api\\.kustomerapp\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create a Kustomer API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Kustomer, create an API key with the permissions your workflows need, then copy the key for the organization you want to connect.",
        },
      ],
    },
    {
      title: "Enter your Kustomer connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          placeholder: "https://yourorg.api.kustomerapp.com",
          required: true,
          target: { kind: "configuration", field: "apiBaseUrl" },
          helperText:
            "Your Kustomer API base URL. Use the organization-specific host if your account has one.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiBaseUrl }) => ({
      url: `${apiBaseUrl}/v1/customers?pageSize=1`,
      expectedStatus: [200, 403],
    }),
  },
});
